import React, { useEffect, useRef } from "react";
import "../Practice/Practice.css";
import { useNavigate } from "react-router-dom";
import gsap from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);

const practiceAreas = [
  {
    title: "Corporate & Securities",
    image: "/demo.webp",
    link: "/practicearea/corporate-securities",
    description:
      "Expert legal counsel for mergers, acquisitions, and corporate governance.",
  },
  {
    title: "Real Estate Law",
    image: "/realestate.webp",
    link: "/practicearea/real-estate",
    description:
      "Comprehensive real estate transactions and property dispute resolution.",
  },
  {
    title: "Healthcare Law",
    image: "/health.webp",
    link: "/practicearea/healthcare",
    description:
      "Regulatory compliance and legal guidance for healthcare providers.",
  },
  {
    title: "Family Law",
    image: "/family.webp",
    link: "/practicearea/family",
    description:
      "Compassionate representation for family matters and domestic cases.",
  },
  {
    title: "Intellectual Property",
    image: "/property.webp",
    link: "/practicearea/intellectual-property",
    description: "Protecting your innovations, trademarks, and creative works.",
  },
  {
    title: "Employment Law",
    image: "/employ.webp",
    link: "/practicearea/employment",
    description:
      "Workplace rights, contracts, and employment dispute resolution.",
  },
];

const PracticeSection = () => {
  const navigate = useNavigate();
  const cardsRef = useRef([]);
  const sectionRef = useRef(null);

  useEffect(() => {
    // Card animations with stagger effect
    cardsRef.current.forEach((card, index) => {
      gsap.fromTo(
        card,
        {
          opacity: 0,
          y: 80,
          scale: 0.9,
        },
        {
          opacity: 1,
          y: 0,
          scale: 1,
          duration: 0.6,
          delay: index * 0.1,
          scrollTrigger: {
            trigger: card,
            start: "top 85%",
            toggleActions: "play none none reverse",
          },
          ease: "power2.out",
        },
      );

      // Add hover animation using GSAP
      card.addEventListener("mouseenter", () => {
        gsap.to(card, {
          y: -10,
          duration: 0.3,
          ease: "power2.out",
        });
        gsap.to(card.querySelector(".card-border-left"), {
          height: "100%",
          duration: 0.3,
          ease: "power2.out",
        });
        gsap.to(card.querySelector(".card-border-right"), {
          height: "100%",
          duration: 0.3,
          ease: "power2.out",
        });
        gsap.to(card.querySelector(".fancy-button"), {
          x: 5,
          duration: 0.3,
          ease: "power2.out",
        });
      });

      card.addEventListener("mouseleave", () => {
        gsap.to(card, {
          y: 0,
          duration: 0.3,
          ease: "power2.in",
        });
        gsap.to(card.querySelector(".card-border-left"), {
          height: "0%",
          duration: 0.3,
          ease: "power2.in",
        });
        gsap.to(card.querySelector(".card-border-right"), {
          height: "0%",
          duration: 0.3,
          ease: "power2.in",
        });
        gsap.to(card.querySelector(".fancy-button"), {
          x: 0,
          duration: 0.3,
          ease: "power2.in",
        });
      });
    });

    return () => {
      ScrollTrigger.getAll().forEach((trigger) => trigger.kill());
    };
  }, []);

  return (
    <section className="practice-section" ref={sectionRef}>
      <div className="header">
        <div className="line"></div>
        <p className="subheading">Professional Legal Solutions</p>
        <h2 className="main-heading">Areas of Legal Expertise</h2>
        <h1 className="faded-text">ADVOCACY</h1>
      </div>

      <div className="card-gridd">
        {practiceAreas.map((area, index) => (
          <div
            key={index}
            className="practice-card fancy-card"
            ref={(el) => (cardsRef.current[index] = el)}
          >
            <div className="card-border-left"></div>
            <div className="card-border-right"></div>
            <img src={area.image} alt={area.title} />
            <div className="card-content">
              <h3>{area.title}</h3>
              <p className="card-description">{area.description}</p>
              <button
                onClick={() => navigate(area.link)}
                className="fancy-button"
              >
                Learn More →
              </button>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
};

export default PracticeSection;
